export function localeToLanguageKey(locale) {
    const split = locale.split('-');
    if (split.length > 0) {
        return split[0].toLowerCase();
    }

    throw new Error(`NOT SURE HOW TO HANDLE LOCALE ${locale}`);
}

export function prefixUrlWithLanguage(language, url, defaultLanguage = 'en') {
    if (!language || language === defaultLanguage) {
        return `/${url}`;
    }

    return `${language}/${url}`;
}